import Location from "../model/Location";
import m from "./module";

const path = "/locations";
const type = "Location";

class LocationService {
  constructor($q, LogService, DataSyncService) {
    "ngInject";
    this.$q = $q;
    this.LogService = LogService;
    this.DataSyncService = DataSyncService;
  }

  create(data) {
    return this.createIsolated(data).then((location) => {
      if (location.id) {
        return this.DataSyncService.setObjectById(type, location.id, location);
      } else {
        return location;
      }
    });
  }

  createIsolated(data) {
    return this.$q.when(new Location(data));
  }

  getAll(config = null) {
    return this.DataSyncService.getMultipleObjects(
      type,
      path,
      (data) => this.create(data),
      config
    ).then((data) => data.map((loc) => this.create(loc)));
  }

  serialize(location) {
    return {
      id: location.id,
      location_id: location.location_id,
      events_custom_instances_id: location.events_custom_instances_id,
      events_custom_field_blocks_id: location.events_custom_field_blocks_id,
      events_custom_forms_id: location.events_custom_forms_id,
      events_custom_forms_products_id: location.events_custom_forms_products_id,
    };
  }
}

export default LocationService;

m.service("LocationService", LocationService);
